export default __webpack_public_path__ + "static/media/waba-account.5a216f5e.jpg";